import { Control } from "../Control.js";

function width(value) {

    if (value === undefined || value === null)
        return '';
    if (value === 'auto' || value === 'max')
        return '.max';
    if (value === 'shrink' || value === 'min')
        return '.min';

    const numericValue = parseInt(value);
    if (Number.isNaN(numericValue) || numericValue <= 0)
        return '';

    return `.s${numericValue}`;

}

export class Group extends Control {

    constructor(parent, options = {}) {

        options = Object.assign({
            width: 12,
            controls: [],
            inline: false
        }, options || {});

        super(parent, options);

        const {
            width = 12,
            controls = [],
            inline = false
        } = options;

        this.width = width;
        this.controls = controls;
        this.inline = inline;

    };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        var props = {},
            style = (width(this.width) || '') + (this.getCss() || ''),
            nodes = this.controls.map(function (control) {
                if (!control)
                    return null;
                return control.render(renderer, vm);
            });

        return renderer.group({ css: style, props }, nodes);

    };

}